export const addAOCreatorsToGridElements = (
  newGridElements,
  newHiddenGridElements,
  savedTemplate,
  templateApplied,
  aggregation,
  campaignId,
  provider,
  overlapData,
) => {
  const creators = overlapData?.audienceOverlap?.data || [];

  creators.map((creator) => {
    const element = {
      key: `overlap-creator-${provider}-${creator.userId}-${campaignId}`,
      label: `overlap-creator-${provider}-${creator.userId}-${campaignId}`,
      creator,
      name: creator.username,
      gridBoxType: "overlap-creator",
      section: `audience-overlap`,
      campaignId,
    };

    // applying saved template

    if (
      (!aggregation && campaignId === "aggregated") ||
      (aggregation && campaignId !== "aggregated")
    ) {
      newHiddenGridElements.push(element);
    } else if (savedTemplate?.length && !templateApplied) {
      if (savedTemplate.find((item) => item.i === element.label)) {
        newGridElements.push(element);
      } else {
        newHiddenGridElements.push(element);
      }
    } else {
      newGridElements.push(element);
    }
  });
};
